module.exports = __webpack_public_path__ + "img/bpb.8984cd2d.png";